var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPasswordImg({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 405 324",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#211D3C",
    d: "M392.27 323.03H12.73A12.73 12.73 0 0 1 0 310.3c137.59-15.99 272.59-15.99 405 0a12.73 12.73 0 0 1-12.73 12.73Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#3F3D56",
    d: "M405 311.05 0 310.3l46.94-78.98.22-.37V56.89A16.09 16.09 0 0 1 63.25 40.8H339.5a16.08 16.08 0 0 1 16.1 16.09v175.25l49.4 78.9Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M62.88 52.03a5.25 5.25 0 0 0-5.24 5.24v158.7a5.24 5.24 0 0 0 5.24 5.25h279.24a5.24 5.24 0 0 0 5.24-5.25V57.28a5.25 5.25 0 0 0-5.24-5.24H62.88Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#211D3C",
    d: "M64.05 242.18a2.24 2.24 0 0 0-2.04 1.3l-14.46 31.45a2.24 2.24 0 0 0 2.04 3.18h304.15a2.25 2.25 0 0 0 2.01-3.25l-15.72-31.44a2.23 2.23 0 0 0-2-1.24H64.04Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M201.38 49.4a3.37 3.37 0 1 0 0-6.73 3.37 3.37 0 0 0 0 6.74Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#211D3C",
    d: "M171.48 284.1a2.24 2.24 0 0 0-2.17 1.66l-3.62 13.48a2.24 2.24 0 0 0 2.16 2.82h69a2.24 2.24 0 0 0 2.12-2.98l-4.66-13.47a2.25 2.25 0 0 0-2.13-1.51h-60.7ZM355.6 228.33v3H46.93l.23-.38v-2.62h308.42Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#EF4B4B",
    d: "M346.98 104.8a52.4 52.4 0 1 0 0-104.8 52.4 52.4 0 0 0 0 104.8Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M368.7 75.24h-43.43a3 3 0 0 1-3-3v-26.2a3 3 0 0 1 3-3h43.42a3 3 0 0 1 3 3v26.2a3 3 0 0 1-3 3Zm-43.43-29.2v26.2h43.43v-26.2h-43.43Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M360.46 46.04H333.5V34.06c0-8.67 5.67-14.97 13.47-14.97 7.81 0 13.48 6.3 13.48 14.97v11.98Zm-23.96-3h20.96v-8.98c0-7.05-4.3-11.98-10.48-11.98-6.17 0-10.48 4.93-10.48 11.98v8.99ZM346.98 61.39a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    d: "M310.4 167.38H94.6a4 4 0 0 1-4-4v-53.52a4 4 0 0 1 4-4h215.8a4 4 0 0 1 4 4v53.53a4 4 0 0 1-4 4ZM94.6 107.46a2.4 2.4 0 0 0-2.4 2.4v53.53a2.4 2.4 0 0 0 2.4 2.4h215.8a2.4 2.4 0 0 0 2.4-2.4v-53.53a2.4 2.4 0 0 0-2.4-2.4H94.6Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    d: "M128.13 150.85a16.28 16.28 0 1 0 0-32.56 16.28 16.28 0 0 0 0 32.56ZM165.73 123.72a2.7 2.7 0 0 0-2.51 3.75 2.7 2.7 0 0 0 2.5 1.67h127.91a2.71 2.71 0 0 0 0-5.42h-127.9ZM165.73 140a2.71 2.71 0 1 0 0 5.42h55.03a2.71 2.71 0 1 0 0-5.43h-55.03Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordImg);
export default __webpack_public_path__ + "static/media/password-img.b216ab276709e3b3e7746c98dd2cc7f9.svg";
export { ForwardRef as ReactComponent };